import { ITypeHeaderProps } from 'components/contentTypes/CustomTypeInput';
import { ArchiveButton } from './ArchiveButton';
import { HeaderWrapper } from './ListHeaderWrapper';
import { PlatformMedicalSpecialityDropdown } from './platform/PlatformMedicalSpecialityDropdown';
import { PlayformReadyButton } from './platform/PlatformReadyCheckbox';

export function VideoPlaylistHeader(props: ITypeHeaderProps) {
  return (
    <HeaderWrapper>
      <PlatformMedicalSpecialityDropdown {...props} />
      <PlayformReadyButton {...props} />
      <ArchiveButton {...props} />
    </HeaderWrapper>
  );
}
